import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../constants/common'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'
import { getUserRoleSelectOptions } from '../UserRoleSelect'

import { USER_EDIT_ROLE_FIELD_NAME } from './UserEditRoleFormModal.constants'

export function getUserEditRoleFormModalValidationSchema(
  initialValues,
  needToCheckNoChanges
) {
  return Yup.object({
    [USER_EDIT_ROLE_FIELD_NAME]: Yup.object().required(true),
  }).when(EMPTY_LIST, {
    is: () => needToCheckNoChanges,
    then: schema =>
      schema.concat(formValidationSchemaNoChanged({ initialValues })),
  })
}

export function getUserEditRoleFormModalSubmitPayload(values) {
  const value = values[USER_EDIT_ROLE_FIELD_NAME]?.value ?? null

  return {
    [USER_EDIT_ROLE_FIELD_NAME]: value,
  }
}

export function getUserEditRoleFormModalInitialValues({ role, t }) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
    [USER_EDIT_ROLE_FIELD_NAME]: role
      ? getUserRoleSelectOptions(t).find(item => item.value === role)
      : null,
  }
}
